import { render, staticRenderFns } from "./CardOverLay.vue?vue&type=template&id=58fa258d"
import script from "./CardOverLay.vue?vue&type=script&lang=js"
export * from "./CardOverLay.vue?vue&type=script&lang=js"
import style0 from "./CardOverLay.vue?vue&type=style&index=0&id=58fa258d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports